import { render } from "./ContactSection.vue?vue&type=template&id=0aee74d2&scoped=true"
import script from "./ContactSection.vue?vue&type=script&lang=js"
export * from "./ContactSection.vue?vue&type=script&lang=js"

import "./ContactSection.vue?vue&type=style&index=0&id=0aee74d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aee74d2"]])

export default __exports__